import React, { useState } from "react";

import { CopilotContext } from "src/unifiedCopilot/context/CopilotContext";
import { createCopilotStore } from "src/unifiedCopilot/context/store";

/**
 * Holds the unified copilot's frontend context.
 */
export const CopilotContextProvider: React.FC<{
  children: React.ReactNode;
  // Changing the resetKey will reset the store
  resetKey?: string;
}> = ({ children, resetKey }) => {
  const [scope, setScope] = useState(() => ({
    resetKey,
    store: createCopilotStore(),
  }));

  // Done here instead of an effect because doing it in an effect
  // would keep the previous store around for one render, while
  // setting "key" doesnt have this problem
  if (scope.resetKey !== resetKey) {
    setScope({ resetKey, store: createCopilotStore() });
  }

  return <CopilotContext value={scope.store}>{children}</CopilotContext>;
};
